import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './components/auth/LoginPage';
import OverviewPage from './pages/OverviewPage';
import Learning from './pages/Learning';
import StudentsPage from './pages/StudentsPage';
import UserDetail from './pages/UserDetail';
import Content from './pages/Content';
import Teachers from './pages/Teachers';
import TeacherDetail from './pages/TeacherDetail';
import CoachingCenters from './pages/CoachingCenters';
import CoachingCenterDetail from './pages/CoachingCenterDetail';
import Batches from './pages/Batches';
import BatchDetail from './pages/BatchDetail';
import CognitiveMastery from './pages/CognitiveMastery';
import FocusLearningPage from './pages/FocusLearningPage';
import FunnelHubPage from './pages/FunnelHubPage';

import RetentionPage from './pages/RetentionPage';
import RevenueHubPage from './pages/RevenueHubPage';
import DeletionFunnelPage from './pages/DeletionFunnelPage';

// Teacher Dashboard v2
import TeacherLayout from './components/teacher-v2/TeacherLayout';
import ContextStudentsTab from './pages/teacher-v2/ContextStudentsTab';
import ContextClassGapsTab from './pages/teacher-v2/ContextClassGapsTab';
import ContextParentDataTab from './pages/teacher-v2/ContextParentDataTab';

function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Operations */}
        <Route path="/" element={<OverviewPage />} />
        <Route path="/learning" element={<Learning />} />
        <Route path="/users" element={<StudentsPage />} />
        <Route path="/users/:userId" element={<UserDetail />} />
        <Route path="/content" element={<Content />} />
        <Route path="/teachers" element={<Teachers />} />
        <Route path="/teachers/:teacherId" element={<TeacherDetail />} />
        <Route path="/coaching-centers" element={<CoachingCenters />} />
        <Route path="/coaching-centers/:centerId" element={<CoachingCenterDetail />} />
        <Route path="/batches" element={<Batches />} />
        <Route path="/batches/:batchId" element={<BatchDetail />} />
        <Route path="/cognitive-mastery" element={<CognitiveMastery />} />
        <Route path="/focus-learning" element={<FocusLearningPage />} />

        {/* Growth & Revenue */}
        <Route path="/funnel" element={<FunnelHubPage />} />
        <Route path="/entry-funnel" element={<Navigate to="/funnel" replace />} />
        <Route path="/retention" element={<RetentionPage />} />
        <Route path="/revenue" element={<RevenueHubPage />} />
        <Route path="/deletion-funnel" element={<DeletionFunnelPage />} />
        <Route path="/payments" element={<Navigate to="/revenue?tab=payments" replace />} />

      </Route>

      {/* Teacher Dashboard v2 (Phase E) — separate layout (dark sidebar, no admin nav) */}
      <Route
        element={
          <ProtectedRoute>
            <TeacherLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/teachers/:teacherId/batches/:batchId/:subject" element={<ContextStudentsTab />} />
        <Route path="/teachers/:teacherId/batches/:batchId/:subject/class-gaps" element={<ContextClassGapsTab />} />
        <Route path="/teachers/:teacherId/batches/:batchId/:subject/parent-data" element={<ContextParentDataTab />} />
        {/* Bare /teachers/:teacherId redirects to default context inside TeacherLayout */}
        <Route path="/teachers/:teacherId/v2" element={<div />} />
      </Route>
    </Routes>
  );
}

export default App;
